import { connect } from 'react-redux';
import { isIosMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { IconModerator } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { openDialog } from '../../../base/dialog/actions';
import ModeratorDialog from '../../../base/moderatorDialog/components/ModeratorDialog';
/**
 * Implementation of a button for toggling fullscreen state.
 */
class ModeratorButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.moderator';
        this.label = 'toolbar.moderator';
        this.tooltip = 'toolbar.moderator';
        this.icon = IconModerator;
    }
    /**
    * Handles clicking the button, and toggles fullscreen.
    *
    * @private
    * @returns {void}
    */
    _handleClick() {
        const { dispatch } = this.props;
        // sendAnalytics(createToolbarEvent(
        //     'toggle.fullscreen',
        //     {
        //         enable: !_fullScreen
        //     }));
        // dispatch(closeOverflowMenuIfOpen());
        // dispatch(setFullScreen(!_fullScreen));
        dispatch(openDialog(ModeratorDialog));
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        // _fullScreen: state['features/toolbox'].fullScreen,
        visible: !isIosMobileBrowser()
    };
};
export default translate(connect(mapStateToProps)(ModeratorButton));
